import React from "react"
import ListItem from "./ListItem"


export default function List({ trainings }) {
  return (
    <div id="List">
      { trainings.length ?
        <table className="qms-training-table">
          <thead>
            <tr className="qms-training-table-head">
              <th>Type</th>
              <th>Number</th>
              <th>Title</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            { trainings.map(training => {
              return <ListItem key={ training.id } training={ training } />
            }) }
          </tbody>
        </table>
        :
        <h5>There are no trainings that match the search term.</h5>
      }

    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Trainings/List.js